import { SNACKBAR_CLEAR, SNACKBAR_ENQUEUE } from './snackbar.actions';
import {
	ISnackbarState,
	SnackbarAction,
	SnackbarMessage
} from './snackbar.types';
import { produce } from 'immer';

const snackbarInitialState: ISnackbarState = {
	queue: undefined
};

export function snackbarReducer(
	state: ISnackbarState = snackbarInitialState,
	action: SnackbarAction
): ISnackbarState {
	switch (action.type) {
		case SNACKBAR_ENQUEUE: {
			return setQueue(state, action.payload as SnackbarMessage);
		}
		case SNACKBAR_CLEAR: {
			return clearQueue(state);
		}
		default: {
			return state;
		}
	}
}

function setQueue(
	currentState: ISnackbarState,
	notification: SnackbarMessage
): ISnackbarState {
	return produce(currentState, (draftState: ISnackbarState) => {
		draftState.queue = notification;
	});
}

function clearQueue(currentState: ISnackbarState): ISnackbarState {
	return produce(currentState, (draftState: ISnackbarState) => {
		draftState.queue = undefined;
	});
}
